import * as types from '../types';

  const initialState = {
    error: false,
    success: false,
    vendorDetails: [],
    loading: false
  };
  
  const vendorDetailsReducer = (state = initialState, action:any) => {
    const { type, payload } = action;
    
    switch (type) {
      case types.SEND_VENDOR_DETAILS_BEGIN:
        return {
          ...state,
          vendorDetails: [],
          error: null,
          success: false,
          loading: true,
        };

      case types.SEND_VENDOR_DETAILS_SUCCESS:
        return {
          ...state,
            vendorDetails: payload,
            error: false,
            success: true,
            loading: false,
        };

      case types.SEND_VENDOR_DETAILS_FAILURE:
        return {
          ...state,
          vendorDetails: '{}',
          success: false,
          error: true,
          loading: false
        };
        case types.SEND_VENDOR_DETAILS_RESET:
        return {
            ...state,
        };
      default:
        return state;
    }
  }

  export default vendorDetailsReducer;